import { render } from "./guidance.vue?vue&type=template&id=38f5d5f8&scoped=true"
import script from "./guidance.vue?vue&type=script&lang=js"
export * from "./guidance.vue?vue&type=script&lang=js"

import "./guidance.vue?vue&type=style&index=0&id=38f5d5f8&lang=scss&scoped=true"

import exportComponent from "/Users/wlxqxxf/铭方营养/nutrition-web-wechat/node_modules/_vue-loader@16.8.2@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38f5d5f8"]])

export default __exports__